package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.templates.template4.components.Template4AboutMeImage
import com.anjuros.website.templates.template4.components.Template4AboutMeImageSmall
import com.anjuros.website.templates.template4.components.Template4AboutMeText
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import org.jetbrains.compose.web.css.px

@Composable
fun Template4AboutSection(){
    Box(
        modifier = Modifier
            .id(Template4Section.About_Me.id)
            .fillMaxSize()
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {


        SimpleGrid (
            numColumns = numColumns(base = 1),
            modifier = Modifier.displayUntil(Breakpoint.MD)) {
            Template4AboutMeImageSmall()
            Template4AboutMeText()
        }

        SimpleGrid (
            numColumns = numColumns(base = 2),
            modifier = Modifier.displayIfAtLeast(Breakpoint.MD)) {
            Template4AboutMeText()
            Template4AboutMeImage()
        }

    }
}